import React, { useCallback } from 'react'
import { PrivateNotesCard } from '../../components/PrivateNotesCard.jsx'
import { useReflectionPrivateNotes } from '../hooks/useReflectionPrivateNotes.js'

/**
 * Thin wrapper around the shared PrivateNotesCard component.
 * Passes onLoad/onSave callbacks so PrivateNotesCard uses
 * reflection-specific GraphQL queries instead of session ones.
 */
export function ReflectionPrivateNotes({ reflectionId, ownerUserId, side }) {
  const { notes, loading, updateNotes } = useReflectionPrivateNotes({
    reflectionId,
    ownerUserId,
    enabled: true,
  })

  const handleLoad = useCallback(() => {
    return { text: notes.text || '' }
  }, [notes.text])

  const handleSave = useCallback(async (_id, data) => {
    await updateNotes(data.notes)
  }, [updateNotes])

  return (
    <PrivateNotesCard
      sessionId={reflectionId}
      reportId={side === 'MANAGER' ? ownerUserId : null}
      initialNotes={loading ? '' : (notes.text || '')}
      readOnly={false}
      onLoad={handleLoad}
      onSave={handleSave}
    />
  )
}
